import { render, staticRenderFns } from "./ExhibitionPageBody.vue?vue&type=template&id=b9a15226&scoped=true&"
import script from "./ExhibitionPageBody.vue?vue&type=script&lang=js&"
export * from "./ExhibitionPageBody.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionPageBody.vue?vue&type=style&index=0&id=b9a15226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a15226",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9a15226')) {
      api.createRecord('b9a15226', component.options)
    } else {
      api.reload('b9a15226', component.options)
    }
    module.hot.accept("./ExhibitionPageBody.vue?vue&type=template&id=b9a15226&scoped=true&", function () {
      api.rerender('b9a15226', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Visitors/ExhibitionPage/ExhibitionPageBody.vue"
export default component.exports